import qMark from 'public/static/images/srp/Qmark.svg';
import { ButtonHTMLAttributes } from 'react';
import { formatPrice } from 'components/Srp/SearchResultCard/utils';
import { colors, screen } from 'components/styles/variables';

export type MonthlyPaymentCtaProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  value: number;
};

export default function MonthlyPaymentCta({ onClick, value }: MonthlyPaymentCtaProps): JSX.Element {
  return (
    <>
      <button
        data-testid="monthly-payment-cta"
        className="monthly-payment-cta"
        onClick={onClick}
        aria-label="monthly-payment-calculator"
      >
        <div className="monthly-payment-value">est. {formatPrice(value)}/mo</div>
        <div className="monthly-payment-icon" />
      </button>
      <style jsx>{`
        .monthly-payment-cta {
          border: none;
          background-color: white;
          cursor: pointer;
          height: 19px;
          white-space: nowrap;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
          padding: 0;
        }

        .monthly-payment-value {
          line-height: 20px;
          text-align: right;
          letter-spacing: 0.2px;
          font-weight: 400;
          font-size: 16px;
          color: ${colors.G3};
        }

        @media (max-width: ${screen.xsMax}) {
          .monthly-payment-value {
            font-size: 14px;
          }
        }

        .monthly-payment-icon {
          background-image: url(${qMark});
          background-repeat: no-repeat;
          background-position: center;
          width: 16px;
          height: 19px;
        }
      `}</style>
    </>
  );
}
